<template>
	<div class="news-wrap">
		<el-breadcrumb separator="/" class="path">
			<el-breadcrumb-item :to="{ path: '/' }" class="path-home"><i class="n el-icon-s-home"></i>首页</el-breadcrumb-item>
			<el-breadcrumb-item class="path-news">行业动态</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="news" v-loading="loading">
			<div class="content">
				<div class="left-column">
					<div class="sub-list">
						<sub-title title="精选导读"></sub-title>
						<div class="list">
							<div class="item" v-for="(item,i) in flagList" :key="i">
								<router-link :to="`/news-detail-${item.id}`" target="_blank">
								<el-image fit="cover" class="image" :src="$img(item.image)" @error="item.image = defaultGoodsImage" />
								<p>{{item.title}}</p>
								</router-link>
							</div>
						</div>
					</div>
					<div class="tab-list">
						<el-tabs >
						  <el-tab-pane v-for="(tab,i) in tabs" :key="tab.id">
							  <!-- <i class="el-icon-date"></i> -->
						    <span slot="label">{{tab.name}}</span>
						    <div class="list" >
								<list2 :list="tab.list"></list2>
							</div>
						  </el-tab-pane>
						</el-tabs>
					</div>
				</div>
				<div class="right-column">
					<sidebar></sidebar>
				</div>
			</div>
			<div class="ad-1"  v-if="ad1">
				<el-image :src="$img(ad1.adv_image)" fit="cover" @click="$router.pushToTab(ad1.adv_url.url)" />
			</div>
		</div>
	</div>
</template>

<script>
	import {
		newsList,
		newsCat
	} from "@/api/cms/news";
	import { adList } from "@/api/website"
	import { mapGetters } from "vuex"
	import SubTitle from "@/components/SubTitle"
	import DescText from "@/components/DescText"
	import sidebar from "./components/sidebar"
	import list2 from "./components/list2"
	
	export default {
		name: "news",
		components: {
			SubTitle,
			DescText,
			sidebar,
			list2
		},
		data: () => {
			return {
				classList:[],
				list: [],
				currentId: 0,
				loading: true,
				flagList:[],
				tabs:[],
				ad1:null,
			};
		},
		created() {
			this.getInfo();
			// this.$util.seo({
			// 	title:`混凝土机械新闻网，混凝土机械行业新闻，混凝土机械租赁专题，混凝土机械施工设备招标信息-中械云配新闻资讯`,
			// 	keywords:`混凝土机械新闻网，混凝土机械行业新闻，混凝土机械租赁专题，混凝土机械施工设备招标信息`,
			// 	description:`中械云配提供混凝土机械行业资讯，混凝土机械租赁专题，公路工程、施工设备招标信息，拟在建项目信息等，是混凝土机械行业从业者看工程机械新闻的网站！`,
			// })
		},
		computed: {
		    ...mapGetters(["defaultGoodsImage"])
		},
		methods: {
			menuOther(id) {
				this.currentId = id;
				this.$router.push({
					path: "/cms/news/listother-" + id
				});
			},
			getInfo() {
				// this.loading = false;
				
				this.getFlagList()
				this.getCat()
				this.getAd1();
				// newsList({
				// 		app_module: "admin"
				// 	})
				// 	.then(res => {
				// 		if (res.code == 0 && res.data) {
				// 			this.$router.push({
				// 				path: "/cms/news/listother-" + res.data[0].class_id
				// 			});
				// 			this.currentId = res.data[0].class_id;
				// 			this.newsList = res.data;
				// 		}
				// 		this.loading = false;
				// 	})
				// 	.catch(err => {
				// 		this.loading = false;
				// 		this.$message.error(err.message);
				// 	});
			},
			getFlagList(){
				newsList({
					flag:1,
					page_size:3
				}).then(res=>{
					if (res.code == 0 && res.data) {
						this.flagList = res.data.list;
					}
					this.loading = false;
				}).catch(err => {
					this.loading = false;
					this.$message.error(err.message);
				});
			},
			getCat(){
				newsCat({
					list:true,
					// exclude:15,
					ids:[
						10,13,14,16,18
					]
				}).then(res=>{
					console.log(2222,res)
					if (res.code == 0 && res.data) {
						this.tabs = res.data;
					}
				})
			},
			
			getAd1(){
				adList({ keyword: "PC_NEWS_INDEX" })
				    .then(res => {
				        this.ad1 = res.data.adv_list[0]
				    })
				    .catch(err => {
				    })
			}
			// getNewsList(cat_id){
			// 	newsList({
			// 		cat_id:cat_id,
			// 		page_size:10
			// 	}).then(res=>{
			// 		if (res.code == 0 && res.data) {
			// 			this.tabs.forEach((v,i)=>{
			// 				if(v.id == cat_id)
			// 				{
			// 					v.list = res.data.list
			// 				}
			// 			})
			// 			this.$set('tabs',this.tabs)
			// 		}
			// 	}).catch(err => {
			// 		this.$message.error(err.message);
			// 	});
			// }
		}
	};
</script>
<style lang="scss" scoped>
.news-wrap {
	background: #ffffff;
	.path {
		padding: 15px 0;
	}
}
.ad-1{
	height: 80px;
	overflow: hidden;
}
.news {
	// display: flex;
	padding-bottom: 20px;
}
	
.news .content{
	display: flex;
	flex-flow: wrap;
	width: 1210px;
	margin-bottom: 20px;
	.left-column{
		width: 900px;
		// flex: 1;
		display: block;
		.sub-list{
			.list{
				display: flex;
				.item:first-child{
					margin-left: 0;
				}
				.item{
					width: 33.333%;
					margin-left: 30px;
					// padding-bottom: 10px;
					border: 1px solid #efefef;
					margin-bottom: 20px;
					overflow:hidden;
					.image{
						width: 100%;
						height: 200px;
					}
					p{
						padding: 5px 10px;
						overflow: hidden;
						text-overflow:ellipsis;
						white-space: nowrap;
					}
					// padding: 15px;
				}
			}
		}
		.tab-list{
			.list{
				.item{
					display: block;
					h2{
						padding: 5px;
						width: 100%;
						display: block;
						overflow: hidden;
						text-overflow:ellipsis;
						white-space: nowrap;
						line-height: 60px;
					}
					.image{
						width: 22%;
						float: left;
						height: 140px;
					}
					.con{
						width: 78%;
						float: left;
						padding: 0  0 0 15px;
						overflow: hidden;
						box-sizing: border-box;
						.text{
							height: 115px;
						}
						.tags{
							span{
								float: right;
							}
						}
					}
				}
			}
		}
	}
	.right-column{
		// width: 260px;
		flex: 1;
		padding-left: 20px;
		overflow: hidden;
	}
}
.news .ad{
	display: block;
}
</style>
